<table *ngIf="viewModel$ | async as viewModel">
  <colgroup>
    <col style="width: 40%" />
    <col style="width: 30%" />
    <col style="width: 30%" />
  </colgroup>
  <tr>
    <th></th>
    <th>Event</th>
    <th>Job</th>
  </tr>
  <tr>
    <td>Charges</td>
    <td>
      {{
        viewModel.event?.discountedSubTotalWithoutDamages / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
    <td>
      {{
        viewModel.event?.discountedSubTotalWithoutDamages / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
  </tr>
  <tr>
    <td>Discounts</td>
    <td>
      {{
        viewModel.event.discountTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
    <td>
      {{
        viewModel.job.discountTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
  </tr>
  <tr *ngIf="viewModel.job?.taxTotal > 0">
    <td>Taxes</td>
    <td>
      {{
        viewModel.event?.taxTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
    <td>
      {{
        viewModel.job?.taxTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
  </tr>
  <tr class="total-row">
    <td>Total</td>
    <td>
      {{
        viewModel.event?.total / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
    <td>
      {{
        viewModel.job?.total / 100 | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
  </tr>
  <tr>
    <td>Paid</td>
    <td></td>
    <td>
      <span>{{
        viewModel.job?.paidTotal || 0 | freyaCurrency: viewModel.job?.currency
      }}</span>
    </td>
  </tr>
  <tr>
    <td>Balance</td>
    <td
      [ngClass]="{
        'td-with-btn': viewModel.job?.total - viewModel.job?.paidTotal,
      }"
    >
      <button
        *ngIf="viewModel.job?.total - viewModel.job?.paidTotal && !readonly && viewModel.collectibles"
        pButton
        icon="pi pi-credit-card"
        class="p-button-text p-m-1 workorders-btn-text"
        label="Pay"
        [disabled]="!viewModel.collectibles.enabled"
        (click)="store.dispatch(paymentActions.workOrderCreateTransactionButtonClicked({
          jobId: viewModel.collectibles.jobId,
          customerId: viewModel.collectibles.customerId,
          currency: viewModel.collectibles.currency,
          invoiceId: viewModel.collectibles.eventInvoiceId,
          amountMinor: viewModel.collectibles.eventAmountMinor
        }))"
      ></button>
    </td>
    <td>
      {{
        viewModel.job?.total - viewModel.job?.paidTotal || 0
          | freyaCurrency: viewModel.job?.currency
      }}
    </td>
  </tr>
  <tr *ngIf="viewModel.job?.damageTotal">
    <td>Damages</td>
    <td>
      {{
        viewModel.event?.damageTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
    <td>
      {{
        viewModel.job?.damageTotal / 100
          | currency: viewModel.job?.currency || 'USD'
      }}
    </td>
  </tr>
  <tr
    class="toggle-row"
    (click)="
      store.dispatch(
        actions.showConfidentialInfoToggleButtonClicked({ eventId: eventId })
      )
    "
  >
    <td colspan="3">
      {{ viewModel.showConfidentialInfo ? 'Hide' : 'Show' }} office information
      <span>
        <i
          [class]="
            viewModel.showConfidentialInfo
              ? 'pi pi-chevron-up'
              : 'pi pi-chevron-down'
          "
        ></i>
      </span>
    </td>
  </tr>

  <ng-container *ngIf="viewModel.showConfidentialInfo">
    <ng-container *hasPermission="['expenses.view']">
      <ng-container *ngIf="viewModel.job?.total !== 0">
        <tr
          pTooltip="The expenses directly associated with this job"
          tooltipPosition="left"
        >
          <td>Cost</td>
          <td>
            {{
              viewModel.event?.expenseTotal
                | freyaCurrency: viewModel.job?.currency
            }}
          </td>
          <td>
            {{
              viewModel.job?.expenseTotal
                | freyaCurrency: viewModel.job?.currency
            }}
          </td>
        </tr>
        <tr
          pTooltip="Gross Margin is your sub total minus your costs of goods sold (expenses)"
          tooltipPosition="left"
        >
          <td>Gross Margin</td>
          <td>
            {{
              viewModel.event?.discountedSubTotal -
                viewModel.event?.expenseTotal || 0
                | freyaCurrency: viewModel.job?.currency
            }}
          </td>
          <td>
            {{
              viewModel.job?.discountedSubTotal - viewModel.job?.expenseTotal ||
                0 | freyaCurrency: viewModel.job?.currency
            }}
          </td>
        </tr>
        <tr
          pTooltip="Gross profit margin is the difference between revenue and cost of goods sold, divided by revenue."
          tooltipPosition="left"
        >
          <td>GPM</td>
          <td>
            {{
              viewModel.event.grossProfitMargin
                | number: '1.2-2'
                | formatAmount: 'percentage'
            }}
          </td>
          <td>
            {{
              viewModel.job.grossProfitMargin
                | number: '1.2-2'
                | formatAmount: 'percentage'
            }}
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>
</table>
